// extracted by mini-css-extract-plugin
module.exports = {"Button":"OrderSummary_Button__3p3-5","Success":"OrderSummary_Success__1gM17","Danger":"OrderSummary_Danger__3uf5S","enable":"OrderSummary_enable__nZZw8"};